import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "시스템 환경 변수",
  "description": "Turborepo에서 사용하는 시스템 변수에 대해 알아봅니다."
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "특정 환경 변수를 설정하여 Turborepo의 동작을 변경할 수 있습니다. 이는 다양한 환경과 머신에 대한 특정 구성을 만드는 데 유용할 수 있습니다."
  }, {
    "heading": "",
    "content": "시스템 환경 변수는 turbo 명령에 직접 제공된 플래그 값에 의해 항상 재정의됩니다."
  }, {
    "heading": "",
    "content": "Remote Cache의 기본\nURL을 설정합니다."
  }, {
    "heading": "",
    "content": "turbo 바이너리의 경로를 수동으로 설정합니다. 기본적으로' '\nturbo는 바이너리를 자동으로 검색하므로 드문 경우에만\n사용해야 합니다."
  }, {
    "heading": "",
    "content": "캐시 소스의 읽기 및 쓰기를 제어합니다.' '"
  }, {
    "heading": "",
    "content": "와 동일한 구문을 사용합니다."
  }, {
    "heading": "",
    "content": "플래그를 사용하는 것과 유사하게 캐시 디렉토리를 설정합니다."
  }, {
    "heading": "",
    "content": "프레임워크 추론"
  }, {
    "heading": "",
    "content": "에서 제외하려는 환경 변수의 접두사를 설정합니다.\n참고: 이것은 사용자가 설정할 필요가 없으며 지원되는\n플랫폼에서 자동으로 구성되어야 합니다."
  }, {
    "heading": "",
    "content": "package.json의 packageManager 필드 검사를\n비활성화합니다. 이 검사를 비활성화하면' '"
  }, {
    "heading": "",
    "content": "오류 및 예상치 못한 캐싱 동작"
  }, {
    "heading": "",
    "content": "이 발생할 수 있습니다. 비활성화하려면 true 또는' '\n1을 사용합니다."
  }, {
    "heading": "",
    "content": "로컬 버전이 없는 경우 전역 turbo가 올바른 로컬 버전을\n설치하도록 활성화합니다."
  }, {
    "heading": "",
    "content": "true로 설정하면 모든 캐싱을 선택 해제하고 모든 작업을\n전체적으로 실행하도록 강제합니다."
  }, {
    "heading": "",
    "content": "전역 turbo가 사용할 로컬 버전을 찾을 수 없을 때 경고를\n비활성화합니다."
  }, {
    "heading": "",
    "content": "실행 중인 turbo 버전의 출력을 비활성화합니다."
  }, {
    "heading": "",
    "content": "로그 순서를\n설정합니다. 허용되는 값은 grouped 및 default\n입니다."
  }, {
    "heading": "",
    "content": "Remote Cache에\n로그인하는 데 사용되는 URL을 설정합니다. 토큰을 동적으로 생성하는\n엔드포인트를 구현하는 자체 호스팅 Remote Cache에만 필요합니다."
  }, {
    "heading": "",
    "content": "새 버전의 turbo를 사용할 수 있을 때 나타나는 업데이트\n알림을 제거합니다. 에코시스템 규칙에 따라' '\nNO_UPDATE_NOTIFIER도 사용할 수 있습니다."
  }, {
    "heading": "",
    "content": "지원되는 CI 환경(Vercel)에서 구성된 환경 변수 키의 CSV입니다.' '\n참고: 이 변수는 제로 구성 환경 변수를 구현하려는\n플랫폼을 위한 것입니다. 최종 사용자로서 이 변수를 사용하도록 의도되지\n않았습니다.' '"
  }, {
    "heading": "",
    "content": "turbo.json에 구성된 환경 변수를 지원되는 플랫폼에 설정된\n환경 변수와 비교하는 검사를 비활성화합니다"
  }, {
    "heading": "",
    "content": "모든 캐시 아티팩트 및 분석 요청 전에 preflight 요청 전송을 활성화합니다.\n후속 업로드 및 다운로드는 리디렉션을 따릅니다.' '\nRemote Caching이 구성된\n경우에만 적용됩니다."
  }, {
    "heading": "",
    "content": "Remote Cache에 쓰기를\n방지하지만 읽기는 허용합니다."
  }, {
    "heading": "",
    "content": "비밀 키로 아티팩트에 서명합니다. 자세한 내용은' '"
  }, {
    "heading": "",
    "content": "아티팩트 무결성 섹션"
  }, {
    "heading": "",
    "content": "을 참조하세요."
  }, {
    "heading": "",
    "content": "turbo가' '\nRemote Cache에서\n아티팩트를 가져오는 시간 초과를 초 단위로 설정합니다."
  }, {
    "heading": "",
    "content": "turbo가' '\nRemote Cache에\n아티팩트를 업로드하는 시간 초과를 초 단위로 설정합니다."
  }, {
    "heading": "",
    "content": "작업을 실행할 때 실행 요약\n을 생성합니다."
  }, {
    "heading": "",
    "content": "base...head에서 변경된 내용을 계산할 때' '\n--affected에서 사용하는 base"
  }, {
    "heading": "",
    "content": "base...head에서 변경된 내용을 계산할 때' '\n--affected에서 사용하는 head"
  }, {
    "heading": "",
    "content": "저장소와 연결된 계정 이름입니다.' '"
  }, {
    "heading": "",
    "content": "Vercel Remote Cache"
  }, {
    "heading": "",
    "content": "를 사용하는 경우 이것은 팀의\n슬러그입니다."
  }, {
    "heading": "",
    "content": "저장소와 연결된 계정 식별자입니다.' '"
  }, {
    "heading": "",
    "content": "Vercel Remote Cache"
  }, {
    "heading": "",
    "content": "를 사용하는 경우 이것은 팀의 ID입니다."
  }, {
    "heading": "",
    "content": "원격 측정이 활성화되어 있음을 알려주는\n메시지를 비활성화합니다."
  }, {
    "heading": "",
    "content": "Remote Cache에\n액세스하기 위한 인증용 Bearer 토큰입니다."
  }, {
    "heading": "",
    "content": "true 또는 1이 전달되면 TUI를 활성화하고, false 또는 0이 전달되면\n비활성화합니다."
  }, {
    "heading": "",
    "content": "실행 또는 감시 모드에서' '"
  }, {
    "heading": "",
    "content": "동시성"
  }, {
    "heading": "",
    "content": "설정을 제어합니다."
  }, {
    "heading": "",
    "content": "인증 중 SSO 로그인 콜백 서버에 사용되는 기본 포트(9789)를 재정의합니다."
  }, {
    "heading": "작업의-환경-변수",
    "content": "Turborepo는 작업이 실행되는 동안 다음 환경 변수를 작업 내에서 사용할 수 있도록 합니다:"
  }, {
    "heading": "작업의-환경-변수",
    "content": "변수"
  }, {
    "heading": "작업의-환경-변수",
    "content": "설명"
  }, {
    "heading": "작업의-환경-변수",
    "content": "TURBO_HASH"
  }, {
    "heading": "작업의-환경-변수",
    "content": "현재 실행 중인 작업의 해시입니다."
  }, {
    "heading": "작업의-환경-변수",
    "content": "TURBO_IS_TUI"
  }, {
    "heading": "작업의-환경-변수",
    "content": "TUI를 사용할 때 이 변수는 true로 설정됩니다."
  }, {
    "heading": "작업의-환경-변수",
    "content": "TURBO_IS_MFE"
  }, {
    "heading": "작업의-환경-변수",
    "content": "마이크로프론트엔드를 사용할 때 이 변수는 애플리케이션의 microfrontends.json에 정의된 포트로 설정됩니다."
  }],
  "headings": [{
    "id": "작업의-환경-변수",
    "content": "작업의 환경 변수"
  }]
};
import {Heading} from 'fumadocs-ui/components/heading';
export const toc = [{
  depth: 2,
  url: "#작업의-환경-변수",
  title: _jsx(_Fragment, {
    children: "작업의 환경 변수"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    p: "p",
    table: "table",
    tbody: "tbody",
    td: "td",
    th: "th",
    thead: "thead",
    tr: "tr",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "특정 환경 변수를 설정하여 Turborepo의 동작을 변경할 수 있습니다. 이는 다양한 환경과 머신에 대한 특정 구성을 만드는 데 유용할 수 있습니다."
    }), "\n", _jsxs(_components.p, {
      children: ["시스템 환경 변수는 ", _jsx(_components.code, {
        children: "turbo"
      }), " 명령에 직접 제공된 플래그 값에 의해 항상 재정의됩니다."]
    }), "\n", _jsxs("table", {
      id: "system-environment-variables-table",
      children: [_jsx("thead", {
        children: _jsxs("tr", {
          children: [_jsx("th", {
            children: "변수"
          }), _jsx("th", {
            children: "설명"
          })]
        })
      }), _jsxs("tbody", {
        children: [_jsxs("tr", {
          id: "force_color",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "FORCE_COLOR"
            })
          }), _jsx("td", {
            children: "터미널 로그에 색상을 강제로 표시합니다"
          })]
        }), _jsxs("tr", {
          id: "turbo_api",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_API"
            })
          }), _jsx("td", {
            children: _jsxs(_components.p, {
              children: [_jsx("a", {
                href: "/docs/core-concepts/remote-caching",
                children: "Remote Cache"
              }), "의 기본\nURL을 설정합니다."]
            })
          })]
        }), _jsxs("tr", {
          id: "turbo_binary_path",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: _jsx("code", {
                children: "TURBO_BINARY_PATH"
              })
            })
          }), _jsx("td", {
            children: _jsxs(_components.p, {
              children: [_jsx("code", {
                children: "turbo"
              }), " 바이너리의 경로를 수동으로 설정합니다. 기본적으로", ' ', "\n", _jsx("code", {
                children: "turbo"
              }), "는 바이너리를 자동으로 검색하므로 드문 경우에만\n사용해야 합니다."]
            })
          })]
        }), _jsxs("tr", {
          id: "turbo_cache",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: _jsx("code", {
                children: "TURBO_CACHE"
              })
            })
          }), _jsxs("td", {
            children: [_jsxs(_components.p, {
              children: ["캐시 소스의 읽기 및 쓰기를 제어합니다.", ' ']
            }), _jsx("a", {
              href: "/docs/reference/run#--cache-options",
              children: _jsx("code", {
                children: "--cache"
              })
            }), _jsx(_components.p, {
              children: "와 동일한 구문을 사용합니다."
            })]
          })]
        }), _jsxs("tr", {
          id: "turbo_cache_dir",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_CACHE_DIR"
            })
          }), _jsxs("td", {
            children: [_jsx("a", {
              href: "/docs/reference/run#--cache-dir-path",
              children: _jsx("code", {
                children: "--cache-dir"
              })
            }), ' ', _jsx(_components.p, {
              children: "플래그를 사용하는 것과 유사하게 캐시 디렉토리를 설정합니다."
            })]
          })]
        }), _jsxs("tr", {
          id: "turbo_ci_vendor_env_key",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_CI_VENDOR_ENV_KEY"
            })
          }), _jsxs("td", {
            children: [_jsx("a", {
              href: "/docs/crafting-your-repository/using-environment-variables#framework-inference",
              children: _jsx(_components.p, {
                children: "프레임워크 추론"
              })
            }), _jsxs(_components.p, {
              children: ["에서 ", _jsx("strong", {
                children: "제외"
              }), "하려는 환경 변수의 접두사를 설정합니다.", _jsx("span", {}), "\n", _jsx("strong", {
                children: "참고"
              }), ": 이것은 사용자가 설정할 필요가 없으며 지원되는\n플랫폼에서 자동으로 구성되어야 합니다."]
            })]
          })]
        }), _jsxs("tr", {
          id: "turbo_dangerously_disable_package_manager_check",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_DANGEROUSLY_DISABLE_PACKAGE_MANAGER_CHECK"
            })
          }), _jsxs("td", {
            children: [_jsxs(_components.p, {
              children: [_jsx("code", {
                children: "package.json"
              }), "의 ", _jsx("code", {
                children: "packageManager"
              }), " 필드 검사를\n비활성화합니다. 이 검사를 비활성화하면", ' ']
            }), _jsx("a", {
              href: "/docs/reference/run#--dangerously-disable-package-manager-check",
              children: _jsx(_components.p, {
                children: "오류 및 예상치 못한 캐싱 동작"
              })
            }), _jsxs(_components.p, {
              children: ["이 발생할 수 있습니다. 비활성화하려면 ", _jsx("code", {
                children: "true"
              }), " 또는", ' ', "\n", _jsx("code", {
                children: "1"
              }), "을 사용합니다."]
            })]
          })]
        }), _jsxs("tr", {
          id: "turbo_download_local_enabled",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_DOWNLOAD_LOCAL_ENABLED"
            })
          }), _jsx("td", {
            children: _jsxs(_components.p, {
              children: ["로컬 버전이 없는 경우 전역 ", _jsx("code", {
                children: "turbo"
              }), "가 올바른 로컬 버전을\n설치하도록 활성화합니다."]
            })
          })]
        }), _jsxs("tr", {
          id: "turbo_force",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_FORCE"
            })
          }), _jsx("td", {
            children: _jsxs(_components.p, {
              children: [_jsx("code", {
                children: "true"
              }), "로 설정하면 모든 캐싱을 선택 해제하고 모든 작업을\n전체적으로 실행하도록 강제합니다."]
            })
          })]
        }), _jsxs("tr", {
          id: "turbo_global_warning_disabled",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_GLOBAL_WARNING_DISABLED"
            })
          }), _jsx("td", {
            children: _jsxs(_components.p, {
              children: ["전역 ", _jsx("code", {
                children: "turbo"
              }), "가 사용할 로컬 버전을 찾을 수 없을 때 경고를\n비활성화합니다."]
            })
          })]
        }), _jsxs("tr", {
          id: "turbo_print_version_disabled",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_PRINT_VERSION_DISABLED"
            })
          }), _jsx("td", {
            children: _jsxs(_components.p, {
              children: ["실행 중인 ", _jsx("code", {
                children: "turbo"
              }), " 버전의 출력을 비활성화합니다."]
            })
          })]
        }), _jsxs("tr", {
          id: "turbo_log_order",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_LOG_ORDER"
            })
          }), _jsx("td", {
            children: _jsxs(_components.p, {
              children: [_jsx("a", {
                href: "/docs/reference/run#--log-order-option",
                children: "로그 순서"
              }), "를\n설정합니다. 허용되는 값은 ", _jsx("code", {
                children: "grouped"
              }), " 및 ", _jsx("code", {
                children: "default"
              }), "\n입니다."]
            })
          })]
        }), _jsxs("tr", {
          id: "turbo_login",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_LOGIN"
            })
          }), _jsx("td", {
            children: _jsxs(_components.p, {
              children: [_jsx("a", {
                href: "/docs/core-concepts/remote-caching",
                children: "Remote Cache"
              }), "에\n로그인하는 데 사용되는 URL을 설정합니다. 토큰을 동적으로 생성하는\n엔드포인트를 구현하는 자체 호스팅 Remote Cache에만 필요합니다."]
            })
          })]
        }), _jsxs("tr", {
          id: "turbo_no_update_notifier",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_NO_UPDATE_NOTIFIER"
            })
          }), _jsx("td", {
            children: _jsxs(_components.p, {
              children: ["새 버전의 ", _jsx("code", {
                children: "turbo"
              }), "를 사용할 수 있을 때 나타나는 업데이트\n알림을 제거합니다. 에코시스템 규칙에 따라", ' ', "\n", _jsx("code", {
                children: "NO_UPDATE_NOTIFIER"
              }), "도 사용할 수 있습니다."]
            })
          })]
        }), _jsxs("tr", {
          id: "turbo_platform_env",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_PLATFORM_ENV"
            })
          }), _jsx("td", {
            children: _jsxs(_components.p, {
              children: ["지원되는 CI 환경(Vercel)에서 구성된 환경 변수 키의 CSV입니다.", ' ', "\n", _jsx("strong", {
                children: "참고"
              }), ": 이 변수는 제로 구성 환경 변수를 구현하려는\n플랫폼을 위한 것입니다. 최종 사용자로서 이 변수를 사용하도록 의도되지\n않았습니다.", ' ']
            })
          })]
        }), _jsxs("tr", {
          id: "turbo_platform_env_disabled",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_PLATFORM_ENV_DISABLED"
            })
          }), _jsx("td", {
            children: _jsxs(_components.p, {
              children: [_jsx("code", {
                children: "turbo.json"
              }), "에 구성된 환경 변수를 지원되는 플랫폼에 설정된\n환경 변수와 비교하는 검사를 비활성화합니다"]
            })
          })]
        }), _jsxs("tr", {
          id: "turbo_preflight",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_PREFLIGHT"
            })
          }), _jsx("td", {
            children: _jsxs(_components.p, {
              children: ["모든 캐시 아티팩트 및 분석 요청 전에 preflight 요청 전송을 활성화합니다.\n후속 업로드 및 다운로드는 리디렉션을 따릅니다.", ' ', "\n", _jsx("a", {
                href: "/docs/core-concepts/remote-caching",
                children: "Remote Caching"
              }), "이 구성된\n경우에만 적용됩니다."]
            })
          })]
        }), _jsxs("tr", {
          id: "turbo_remote_cache_read_only",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_REMOTE_CACHE_READ_ONLY"
            })
          }), _jsx("td", {
            children: _jsxs(_components.p, {
              children: [_jsx("a", {
                href: "/docs/core-concepts/remote-caching",
                children: "Remote Cache"
              }), "에 쓰기를\n방지하지만 읽기는 허용합니다."]
            })
          })]
        }), _jsxs("tr", {
          id: "turbo_remote_cache_signature_key",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_REMOTE_CACHE_SIGNATURE_KEY"
            })
          }), _jsxs("td", {
            children: [_jsxs(_components.p, {
              children: ["비밀 키로 아티팩트에 서명합니다. 자세한 내용은", ' ']
            }), _jsx("a", {
              href: "/docs/core-concepts/remote-caching#artifact-integrity-and-authenticity-verification",
              children: _jsx(_components.p, {
                children: "아티팩트 무결성 섹션"
              })
            }), _jsx(_components.p, {
              children: "을 참조하세요."
            })]
          })]
        }), _jsxs("tr", {
          id: "turbo_remote_cache_timeout",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_REMOTE_CACHE_TIMEOUT"
            })
          }), _jsx("td", {
            children: _jsxs(_components.p, {
              children: [_jsx("code", {
                children: "turbo"
              }), "가", ' ', "\n", _jsx("a", {
                href: "/docs/core-concepts/remote-caching",
                children: "Remote Cache"
              }), "에서\n아티팩트를 가져오는 시간 초과를 초 단위로 설정합니다."]
            })
          })]
        }), _jsxs("tr", {
          id: "turbo_remote_cache_upload_timeout",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_REMOTE_CACHE_UPLOAD_TIMEOUT"
            })
          }), _jsx("td", {
            children: _jsxs(_components.p, {
              children: [_jsx("code", {
                children: "turbo"
              }), "가", ' ', "\n", _jsx("a", {
                href: "/docs/core-concepts/remote-caching",
                children: "Remote Cache"
              }), "에\n아티팩트를 업로드하는 시간 초과를 초 단위로 설정합니다."]
            })
          })]
        }), _jsxs("tr", {
          id: "turbo_remote_only",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_REMOTE_ONLY"
            })
          }), _jsx("td", {
            children: "모든 작업에 대해 로컬 파일 시스템 캐시를 항상 무시합니다."
          })]
        }), _jsxs("tr", {
          id: "turbo_run_summary",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_RUN_SUMMARY"
            })
          }), _jsx("td", {
            children: _jsxs(_components.p, {
              children: ["작업을 실행할 때 ", _jsx("a", {
                href: "/docs/reference/run#--summarize",
                children: "실행 요약"
              }), "\n을 생성합니다."]
            })
          })]
        }), _jsxs("tr", {
          id: "turbo_scm_base",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_SCM_BASE"
            })
          }), _jsx("td", {
            children: _jsxs(_components.p, {
              children: [_jsx("code", {
                children: "base...head"
              }), "에서 변경된 내용을 계산할 때", ' ', "\n", _jsx("code", {
                children: "--affected"
              }), "에서 사용하는 base"]
            })
          })]
        }), _jsxs("tr", {
          id: "turbo_scm_head",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_SCM_HEAD"
            })
          }), _jsx("td", {
            children: _jsxs(_components.p, {
              children: [_jsx("code", {
                children: "base...head"
              }), "에서 변경된 내용을 계산할 때", ' ', "\n", _jsx("code", {
                children: "--affected"
              }), "에서 사용하는 head"]
            })
          })]
        }), _jsxs("tr", {
          id: "turbo_team",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_TEAM"
            })
          }), _jsxs("td", {
            children: [_jsxs(_components.p, {
              children: ["저장소와 연결된 계정 이름입니다.", ' ']
            }), _jsx("a", {
              href: "https://vercel.com/docs/monorepos/remote-caching#vercel-remote-cache",
              rel: "noreferrer noopener",
              target: "_blank",
              children: _jsx(_components.p, {
                children: "Vercel Remote Cache"
              })
            }), _jsxs(_components.p, {
              children: ["를 사용하는 경우 이것은 ", _jsx(_components.a, {
                href: "https://vercel.com/d?to=%2F%5Bteam%5D%2F%7E%2Fsettings&title=Get+team+slug",
                children: "팀의\n슬러그"
              }), "입니다."]
            })]
          })]
        }), _jsxs("tr", {
          id: "turbo_teamid",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_TEAMID"
            })
          }), _jsxs("td", {
            children: [_jsxs(_components.p, {
              children: ["저장소와 연결된 계정 식별자입니다.", ' ']
            }), _jsx("a", {
              href: "https://vercel.com/docs/monorepos/remote-caching#vercel-remote-cache",
              rel: "noreferrer noopener",
              target: "_blank",
              children: _jsx(_components.p, {
                children: "Vercel Remote Cache"
              })
            }), _jsx(_components.p, {
              children: "를 사용하는 경우 이것은 팀의 ID입니다."
            })]
          })]
        }), _jsxs("tr", {
          id: "turbo_telemetry_message_disabled",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_TELEMETRY_MESSAGE_DISABLED"
            })
          }), _jsx("td", {
            children: _jsxs(_components.p, {
              children: [_jsx("a", {
                href: "/docs/telemetry",
                children: "원격 측정"
              }), "이 활성화되어 있음을 알려주는\n메시지를 비활성화합니다."]
            })
          })]
        }), _jsxs("tr", {
          id: "turbo_token",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_TOKEN"
            })
          }), _jsx("td", {
            children: _jsxs(_components.p, {
              children: [_jsx("a", {
                href: "/docs/core-concepts/remote-caching",
                children: "Remote Cache"
              }), "에\n액세스하기 위한 인증용 Bearer 토큰입니다."]
            })
          })]
        }), _jsxs("tr", {
          id: "turbo_ui",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_UI"
            })
          }), _jsx("td", {
            children: _jsx(_components.p, {
              children: "true 또는 1이 전달되면 TUI를 활성화하고, false 또는 0이 전달되면\n비활성화합니다."
            })
          })]
        }), _jsxs("tr", {
          id: "turbo_concurrency",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_CONCURRENCY"
            })
          }), _jsxs("td", {
            children: [_jsxs(_components.p, {
              children: ["실행 또는 감시 모드에서", ' ']
            }), _jsx("a", {
              href: "/repo/docs/reference/run#--concurrency-number--percentage",
              children: _jsx(_components.p, {
                children: "동시성"
              })
            }), ' ', _jsx(_components.p, {
              children: "설정을 제어합니다."
            })]
          })]
        }), _jsxs("tr", {
          id: "turbo_sso_login_callback_port",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_SSO_LOGIN_CALLBACK_PORT"
            })
          }), _jsx("td", {
            children: _jsx(_components.p, {
              children: "인증 중 SSO 로그인 콜백 서버에 사용되는 기본 포트(9789)를 재정의합니다."
            })
          })]
        })]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "작업의-환경-변수",
      children: "작업의 환경 변수"
    }), "\n", _jsx(_components.p, {
      children: "Turborepo는 작업이 실행되는 동안 다음 환경 변수를 작업 내에서 사용할 수 있도록 합니다:"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "변수"
          }), _jsx(_components.th, {
            children: "설명"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "TURBO_HASH"
            })
          }), _jsx(_components.td, {
            children: "현재 실행 중인 작업의 해시입니다."
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "TURBO_IS_TUI"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.a, {
              href: "/docs/reference/configuration#ui",
              children: "TUI"
            }), "를 사용할 때 이 변수는 ", _jsx(_components.code, {
              children: "true"
            }), "로 설정됩니다."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "TURBO_IS_MFE"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.a, {
              href: "/docs/guides/microfrontends",
              children: "마이크로프론트엔드"
            }), "를 사용할 때 이 변수는 애플리케이션의 ", _jsx(_components.code, {
              children: "microfrontends.json"
            }), "에 정의된 포트로 설정됩니다."]
          })]
        })]
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
